import React from "react";
import {Button,} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

export default function DHButtonRundUmsBoard({label, working, disabled, onClick, style}) {

    return <Button variant="contained" disabled={disabled || working} onClick={() => onClick()} startIcon={working ? <CircularProgress size={20}/> : <ReceiptLongIcon/>}
                   style={{textTransform: "none", letterSpacing:"0.1em", ...style}}>{label !== undefined ? label : "Board/Schreiber verwalten"}</Button>
}